// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__36oWF","active":"MenuItem_active__3Jurv"};